var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"interval-indicator",class:{
        'interval-indicator--invalid': _vm.isInvalid,
        'interval-indicator--selected': _vm.isSelected,
        'interval-indicator--unavailable': _vm.isUnavailable,
    },attrs:{"disabled":_vm.isInvalid || _vm.isUnavailable,"type":"button"},on:{"click":function($event){return _vm.$emit('click:slot', _vm.date, _vm.time)}}})}
var staticRenderFns = []

export { render, staticRenderFns }